"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GenerateReceiptValidation = void 0;
class GenerateReceiptValidation {
    static isValid(entity) {
        // Validate entity.charging_transaction_attempt_id for existence and correct type.
        if (entity.charging_transaction_attempt_id == undefined)
            return false;
        if (typeof entity.charging_transaction_attempt_id !== "string")
            return false;
        // Validate entity.email_address for existence and correct type.
        if (entity.email_address == undefined)
            return false;
        if (typeof entity.email_address !== "string")
            return false;
        return true;
    }
}
exports.GenerateReceiptValidation = GenerateReceiptValidation;
